import {instrumentsApi} from "../api/api";
import {Instrument} from "../gen/api";

class InstrumentService {
  getInstruments(): Promise<Instrument[]> {
    return instrumentsApi.getInstruments()
    .then(response => {
      if (response.status === 200) return response.data;
      else throw new Error("Rest call failed with code " + response.status)
    });
  }

  getInstrument(id: string): Promise<Instrument> {
    return instrumentsApi.getById(id)
    .then(response => {
      if (response.status === 200) return response.data;
      else throw new Error("Rest call failed with code " + response.status)
    });
  }

  createInstrument(instrument: Instrument): Promise<Instrument> {
    return instrumentsApi.createInstrument(instrument, {auth: {username: "", password: ""}})
    .then(response => {
      if (response.status === 201) return response.data;
      else throw new Error("Rest call failed with code " + response.status)
    });
  }

  updateInstrument(id: string, instrument: Instrument): Promise<Instrument> {
    return instrumentsApi.updateInstrument(id, instrument)
    .then(response => {
      if (response.status === 200) return response.data;
      else throw new Error("Rest call failed with code " + response.status)
    });
  }
}

export default new InstrumentService();
